var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEntrance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1776_229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6217 51.8462H39.7232C38.7703 51.8462 37.998 52.6187 37.998 53.5714C37.998 54.5241 38.7703 55.2966 39.7232 55.2966H45.6217C46.5748 55.2966 47.3469 54.5241 47.3469 53.5714C47.3469 52.6187 46.5746 51.8462 45.6217 51.8462Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8281 5.00884H55.3785V1.72524C55.3785 1.1893 55.1293 0.68364 54.7043 0.357273C54.2789 0.0307102 53.7264 -0.080032 53.2086 0.0584446L18.727 9.25356C17.9717 9.45493 17.4463 10.1389 17.4463 10.9206V16.493C17.4463 17.4457 18.2186 18.2182 19.1715 18.2182C20.1244 18.2182 20.8967 17.4457 20.8967 16.493V12.2461L51.9279 3.97094V96.1704L20.8967 89.9641V22.3079C20.8967 21.3551 20.1244 20.5827 19.1715 20.5827C18.2186 20.5827 17.4463 21.3551 17.4463 22.3079V91.3786C17.4463 92.201 18.0266 92.909 18.8332 93.0702L53.3148 99.9667C53.4271 99.9891 53.5402 100 53.6531 100C54.0486 100 54.4357 99.8643 54.7469 99.6092C55.1465 99.2815 55.3783 98.7918 55.3783 98.275V94.9918H71.2777C72.2309 94.9918 73.0029 94.2194 73.0029 93.2666C73.0029 92.3139 72.2307 91.5415 71.2777 91.5415H55.3783V86.619H72.4547C73.4078 86.619 74.1799 85.8465 74.1799 84.8938V15.1071C74.1799 14.1543 73.4076 13.3819 72.4547 13.3819H55.3783V8.45923H79.1025V91.5407H76.6412C75.6881 91.5407 74.916 92.3131 74.916 93.2659C74.916 94.2186 75.6883 94.9911 76.6412 94.9911H80.8277C81.7809 94.9911 82.5529 94.2186 82.5529 93.2659V6.73403C82.5533 5.7813 81.7809 5.00884 80.8281 5.00884ZM70.7297 16.8323V83.168H55.3787V16.8323H70.7297Z",
    fill: "#7A297F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1776_229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrance);
export default __webpack_public_path__ + "static/media/entrance.c99f62ebfdcddb34e2c5bc7489ba72c0.svg";
export { ForwardRef as ReactComponent };